// extracted by mini-css-extract-plugin
export var carrierIcon = "_ye-0";
export var carrierLogo = "_ye-1";
export var detailsSection = "_ye-2";